import { LegalScreen } from '@/components/legal/LegalScreen'

export default function CancellationPolicyRoute() {
  return <LegalScreen slug="cancellation-policy" />
}
